 import {React,useState,useMemo, useCallback } from "react";  
import { useLocation } from "react-router-dom";  
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";  
import ButtonsSection from '../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection';  
import NoteTable from '../../common_nextgen/common_components/NoteScreenComponents/NoteTable';  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import useAccumulatorOverrideScheduleNote from "./hooks/useAccumulatorOverrideScheduleNote";  
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants.js";

const AccumulatorOverrideScheduleNote = () => {  
  const location = useLocation();  
  const { state: stateVal } = location;
  const { axios_helper_no_header } = useAxios();
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  const {
    selectedPriceSchedules = [],
    previousScreen = ROUTE_PATHS.OUT_OF_POCKET_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
  } = currentState;
  console.log(
    "states",
    stateVal,
    currentState,
    selectedPriceSchedules,
    initialIndex,
    previousState
  );
    const navigateToPage = useCustomNavigate();  
  
  const {  
    notes,  
    newNotes,  
    mode,  
    first,  
    rows,  
    totalRecords,  
    currentIndex,  
    setMode,  
    setFirst,  
    setRows,  
    setCurrentIndex,  
    handleSaveNotes,  
    handleChangeNewNote,  
    onPageChange,  
    exportAsCSV  
  } = useAccumulatorOverrideScheduleNote(selectedPriceSchedules, initialIndex);  
  
  const screen_title = "Accumulator Override Schedule Note";  
  const screen_code = "RCAON001";  
  
  const columns = useMemo(
    () =>
      mode === "view"
        ? [
            { key: "aonNote", header: "Note" },
            { key: "chgDate", header: "Added Date" },
            { key: "chgTime", header: "Added Time" },
            { key: "chgUserName", header: "User" },
          ]
        : [{ key: "aonNote", header: "Note" }],
    [mode]
  );
  const handleBack = useCallback(() => {
    if (currentIndex < selectedPriceSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  }, [currentIndex, navigateToPage, setCurrentIndex]);
  
  const handleBackAndSetMode = useCallback(() => {
    handleBack();
    setMode("view");
  }, [handleBack, setMode]);
  
  const handleModeSwitch = useCallback(() => {
    if (mode === "add") {
      setMode("view");
    } else if (mode === "view") {
      setMode("add");
    }
  }, [mode]);
  
  const leftButtons = useMemo(
    () => [
      {
        button_label: "Back",
        button_handeler: handleBackAndSetMode,
        button_key: "F12",
      },
      ...(mode === "add"
        ? [
            {
              button_label: "View Note",
              button_handeler: handleModeSwitch,
              button_key: "F9",
            },
          ]
        : []),
    ],
    [mode, handleBackAndSetMode, handleModeSwitch]
  );

  const rightButtons = useMemo(
    () => [
      ...(mode === "view"
        ? [
            {
              button_label: "Add Note",
              button_handeler: handleModeSwitch,
              button_key: "F9",
            },
          ]
        : []),
      { button_label: "Export as CSV", button_handeler: exportAsCSV },
    ],
    [mode]
  );
  const [paramsData, setParamsData] = useState({  
    aosAccumOvrdSchedule: selectedPriceSchedules[currentIndex].aosAccumOvrdSchedule  
  });  

  const getName = (selectedPriceSchedules, currentIndex) => (  
    <>  
      <strong>Schedule </strong>  
      {selectedPriceSchedules[currentIndex].aosAccumOvrdSchedule}  
      <span className="info-records">
        <strong> Description </strong>
        {selectedPriceSchedules[currentIndex].aosAccumOvrdScdeDesc}
      </span>
      <span >
        <strong> Type </strong>
        {selectedPriceSchedules[currentIndex].aosAccumOvrdScdeType}
      </span>
    </>  
  );  
  
  return (  
    <div className="container grid">  
      <ButtonsSection ctaButtons={leftButtons} align="left" />  
      <div className="left-aligned-section">  
        <div className="header-section">  
          <h1>  
            {screen_title} - <span className="heading-cod">{screen_code}</span>  
          </h1>  
        </div>  
        <p className="head-name">{getName(selectedPriceSchedules, currentIndex)}</p>  
      </div>  
      <div className="button-sections">  
        <ButtonsSection ctaButtons={rightButtons} align="right" />  
      </div>  
      <NoteTable  
        data={notes}  
        columns={columns}  
        mode={mode}  
        maxLength={55}
        newNotes={newNotes}  
        handleChangeNewNote={handleChangeNewNote}  
        handleSaveNotes={handleSaveNotes}  
      />  
      <NextGenPaginator  
        first={first}  
        rows={rows}  
        totalRecords={totalRecords}  
        currentPage={first / rows}  
        rowsPerPageOptions={[10, 25, 50]}  
        onPageChange={onPageChange}  
      />  
    </div>  
  );  
};  
  
export default AccumulatorOverrideScheduleNote;  
